import $, { extend } from 'jquery';
import React from 'react';
import QueryString from 'query-string';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,RespBkMthdMapp,
  TableDatePicker, exportTableToCSV,ConvertDateFormat_Time} from '../function_lib/common_lib';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Comp_Invoice_Products from '../components/comp_invoice_products';
import Comp_Ptr_Invoice from '../components/comp_ptr_invoice';
import Comp_Print_Report from './comp_print_report';

let rf="0";
let _durex="";// for exact date
let queries;

let loginUser="";
let userObject="";
let companyName="";
let clsOnlineOrders;
let _canSearchUri="";
class State_Analysis extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
          _canSearchUri= this.props.match.params.name;

          if(props !=null){
            queries = QueryString.parse(this.props.location.search);
                  if(queries.rf!=null){
                    rf=queries.rf;
                    rf=atob(rf);
                  }else if(queries.durex!=null){
                    _durex=atob(queries.durex);
                  }

                  //alert(rf+" check "+_durex)

          }
        
      }
      this.state={stListZone:[],stListStates:[],stListInvoice:[],stOilChangeLog:[],
        stViewInvoice:[],stRefInvoice:"0",stCourierList:[],
      stInvCourier:[],stBillingAdd:[],stShippingAdd:[],isFilterBuy:"false"};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsOnlineOrders=this;
      }

      setPrtReceipt(item){
        //alert(JSON.stringify(item));
        let encInvoiceId=btoa(item.id);
        clsOnlineOrders.setState({stRefInvoice:encInvoiceId});
      }
/* for child component funciton */



/* end of child component function */
getOilChangeRawLog(item){
   
  // return;
  var map=[];
  map.push({name:"curl_type",value:"getOilChangeRawLog"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  map.push({name:"parent_id",value:btoa(item.id)});
  
  if($("#ser_from_date").val()===""){
    map.push({name:"date_group_v",value:item.date_group_v});
  }else{
    map.push({name:"ser_from_date",value:$("#ser_from_date").val()});
    map.push({name:"ser_to_date",value:$("#ser_to_date").val()});
  }
 
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getOilChangeRawLog";
  CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
    //alert(data);
    if(data!=="0" && data!==""){
      //alert("i m revised vendor ch");

          let listData=JSON.parse(data);
          //alert(JSON.stringify(listData.invoice));
          var strData="";
          //listData.invoice
          //listData["testinvoice"]=[item];
          clsOnlineOrders.setState({stOilChangeLog:listData},()=>{
            
            clsOnlineOrders.forceUpdateHandler();
            RespBkMthdMapp(clsOnlineOrders,"_setbackparam","onDelProCatRel");
          })
        }
  });
}      
resetFilters(){
  $("#ser_states").val("0");
  $("#ser_from_date").val("");
  $("#ser_to_date").val("");
 
  clsOnlineOrders.getOilChangeReports();
}


getStates(){
  var map=[];
  map.push({name:"curl_type",value:"getStates"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getStates";
  CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
         let lsData=JSON.parse(data);
         clsOnlineOrders.setState({stListStates:lsData["states"],stListZone:lsData["state_zone"]},()=>{
          clsOnlineOrders.getOilChangeReports();
         })
        }
  });
}

resetOnSelectQuickDate(){
//   if($("#ser_filter_option").val()!=="0"){
//     $("#ser_from_date").val("");
//     $("#ser_to_date").val("");
//     this.setState({isFilterBuy:"true"});
//   }else{
//     this.setState({isFilterBuy:"false"});
//   }
  
}

getOilChangeReports(isSearch=false)
{
  //alert($("#ser_from_date").val());
//   if($("#ser_filter_option").val()!=="0"){
//     $("#ser_from_date").val("");
//     $("#ser_to_date").val("");
//     //alert("i m in blank");
//   }

        var map=[];
        map.push({name:"curl_type",value:"getStateWiseReportPerformance"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"gb_token",value:userObject[0].app_user_id});
        //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
        map.push({name:"courier_list",value:"yes"});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getStateWiseReportPerformance";
        
          //alert("search on");
          map.push({name:"ser_zone",value:$("#ser_zone").val()});
        map.push({name:"ser_states",value:$("#ser_states").val()});
          //map.push({name:"ser_payment_status",value:$("#ser_PaymentStatus").val()});
          
          map.push({name:"ser_from_date",value:$("#ser_from_date").val()});
          map.push({name:"ser_to_date",value:$("#ser_to_date").val()});
          if(_durex!==""){
            //alert(_durex);
            map.push({name:"ser_direct_date",value:_durex});
            
          }
          

          
         // map.push({name:"ser_filter_option",value:$("#ser_filter_option").val()});
        
        CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);

                var strData="";
                clsOnlineOrders.setState({stListInvoice:listData},()=>{
                  clsOnlineOrders.forceUpdateHandler();
                //   if($("#ser_filter_option").val()!=="0"){
                   
                //     $("#ser_from_date").val("");
                //     $("#ser_to_date").val("");
                //     // alert("i m in blank");
                //   }
                })
              }
        });
}
componentDidMount(){
  this.getStates();
 

  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
$('#divInvoiceProducts').on('hidden.bs.modal', function () {
  //window.location.reload();
  // do something…
});
}


exportExcel(elementId,ignoreCol,expFileName){
    exportTableToCSV(elementId,ignoreCol,expFileName);
  }


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
<div className="col-lg-2 col-md-2 col-sm-4 float-right">
<select  className="form-control form-control-sm" id="ser_zone" name="ser_zone">
<option value={"0"}>-Select Zone-</option>
                                                {this.state.stListZone.map((item,index)=>{
                                                  return <option  value={btoa(item["state_office"])}>{item["state_office"]}</option>
                                                })}
</select>
</div>

<div className="col-lg-2 col-md-2 col-sm-4 float-right">
<select  className="form-control form-control-sm" id="ser_states" name="ser_states">
<option value={"0"}>-Select State-</option>
                                                {this.state.stListStates.map((item,index)=>{
                                                  return <option selected={_canSearchUri===btoa(String(item["id"]))} value={btoa(item["id"])}>{item["name"]}</option>
                                                })}
</select>
</div>
{/* 
<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_txtSearch" name="ser_txtSearch" rf="#btnProSearch" className="_setSearchKeyUp keyEvent_btn form-control form-control-sm" placeholder='Workshop Code/Name/City' />
             </div>
         </div>

</div> */}
{/* 
<div className="col-lg-3 col-md-3 col-sm-3 float-right">
 <select onChange={()=>this.resetOnSelectQuickDate()} className="form-control form-control-sm" id="ser_filter_option" name="ser_filter_option">
<option value={"0"}>-Filter By-</option>
<option selected={rf==="today"} value={"today"}>Today</option>
<option selected={rf==="yesterday"} value={"yesterday"}>Yesterday</option>
<option selected={rf==="last_week"} value={"last_week"}>Last Week</option>
<option selected={rf==="this_week"} value={"this_week"}>This Week</option>

<option selected={rf==="last_15"} value={"last_15"}>Last 15 days</option>
<option selected={rf==="last_month"} value={"last_month"}>Last Month</option>
<option selected={rf==="this_month"} value={"this_month"}>This Month</option>
                                                
</select> 
</div> */}
{(rf==="0" && _durex==="" && this.state.isFilterBuy!=="true" && 0===1)?
<div className='col-lg-4 col-md-4 col-sm-6 float-right'>
<div className="form-group">
         <div className="input-group">
         <input type="hidden" name="ser_from_date" id="ser_from_date" value={""}/>
<input type="hidden" name="ser_to_date" id="ser_to_date" value={""}/>
         <TableDatePicker refName="ser_from_date" />
               
               -TO-
               <TableDatePicker refName="ser_to_date"/>
             </div>
         </div>
</div>:
<>
<input type="hidden" name="ser_from_date" id="ser_from_date" value={""}/>
<input type="hidden" name="ser_to_date" id="ser_to_date" value={""}/>
</>

}




<div className="col-lg-6 col-md-6 col-sm-12 vcenter-item1 float-right">
<div className="input-group">
               
            
             
                 <div id="btnProSearch" name="btnProSearch" onClick={()=>this.getOilChangeReports(true)}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 
                 <div  onClick={()=>this.exportExcel("tbRegionalAnalys","Detailed Log","State_Analysis_Data_CSV")} style={{marginRight:"10px"}} className="btn btn-sm btn-primary">Export Excel</div>

                 <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-danger">Reset</div>
                 </div>
               
             

</div>


    </div>
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "> <b>State Analysis {_durex!==""?" Date:"+ConvertDateFormat_Time(_durex,true,false):''}</b></h3>
              </div>
                <table id="tbRegionalAnalys" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>State Name</th>
                      <th>Installed Machines</th>
                    
                      
                      <th>Oil Changes(till date)</th>
                    </tr>
                  </thead>
                  <tbody id="tbData">
                    {this.state.stListInvoice.map((item,index)=>{
                      return(<tr>
                        <td>{index+1}</td>
                    <td><a href={"../regional_analysis/"+btoa(item["state_id"])+"?rf="+btoa("till_date")}>{item.state_name}</a></td>
                  <td>{item.installed_machines}</td>
                  <td>{item.oil_change}</td>
                  
                 
                    </tr>)
                    })}
                  </tbody>
                </table>
             
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Footer/>
<div className="modal fade bd-example-modal-xl"  id="divEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-xl" role="document">
    <div className="modal-content">
    <div className="modal-header bg-primary">
        <h5 className="modal-title text-white" id="exampleModalLabel">Add New</h5>
        <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" className="text-white">&times;</span>
        </button>
      </div>
      <form id="frmCreate" name="frmCreate">
     
      <div className="modal-body">
      <div className="row">
                {/* <!-- left column --> */}
                <div className="col-md-12">
                    <div className="card card-danger">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="createLogMaster" />
                            <input type="hidden" name="m_type" id="m_type" value="createLogMaster" />
                            <input type="hidden" name="type_id" id="type_id" value="2" />
                            <input type="hidden" name="app_user_id" id="app_user_id" value="" />
                            <div className="card-body">
                                <div className="row">
                               
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">License/Registration Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="details" name="details" className="form-control" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Type *</label>
                                            <div className="input-group input-group-sm">
                                                <select id="parent_id_reg" name="parent_id_reg" className="form-control">
                                                  <option value="0">-Select-</option>
                                                  <option value="entity">Entity</option>
                                                  <option value="contractor">Contractor</option>
                                                  <option value="client">Client</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
            <div className="form-group">
              <label for="exampleInputEmail1">Valid From</label>
              <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                    </div>
                    <input type="text" id="col98" name="col98" className="form-control" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/mm/yyyy" data-mask />
                  </div>
              <small id="emailHelp" className="form-text text-muted">Proposal Form Sign Date</small> </div>
          </div>
                                    <div className="col-lg-3 col-md-3 col-12">
            <div className="form-group">
              <label for="exampleInputEmail1">Valid To</label>
              <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                    </div>
                    <input type="text" id="col98" name="col98" className="form-control" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/mm/yyyy" data-mask />
                  </div>
              <small id="emailHelp" className="form-text text-muted">Proposal Form Sign Date</small> </div>
          </div>
                                    <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
<label for="exampleInputFile">Upload Proof(*img,pdf)</label>
<div className="input-group">
  <div className="custom-file">
    <input type="file" className="custom-file-input" name="exampleInputFile" id="exampleInputFile" />
    <label className="custom-file-label" for="exampleInputFile">Choose file</label>
  </div>
  {/* <div className="input-group-append">
  <button type="button" className="btn btn-primary">Upload Now</button>
  </div> */}
</div>
</div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                            <label for="exampleInputEmail1">Reminder Breif(Days) *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="ref1_id" name="ref1_id" className="form-control" placeholder="Priority Index" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              
                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                            </div>
                        
                    </div>
                </div>
            </div>
      </div>
      <div className="modal-footer">
      <div id="getReponse" style={{color:"red"}}></div>
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
      </div>
      </form>
    </div>
    </div>
    </div>
   <Comp_Print_Report
   ptrColumnHeader={["Workshop Name","Workshop Id","Runtime","Sensor Signal","Coordinates (Lat, Long)","Status","Date"]} 
    ptrColumnName={["business_name","dealer_code","on_off_duration","jar_switch_count","gps_lat_long","sys_valid_oil_change","fmt_entry_date"]}
    totals={[{"col":"Sub Total","col_index":11,"total_value":0},
      {"col":"Pack","col_index":14,"total_value":0},
      {"col":"Amount","col_index":15,"total_value":0}
    ]}
  
    
    ptrOutStandingCols={{"Item":"Product","Item Unit":"Unit","Quantity":"Net Quantity","Sub Total":"Net Amount"}}
    lsOutStandingData={this.state.stOutStanding}
    ptrOutStandingTitle={"Product/Unit Wise Outstanding"}
    
    lsTabelData={this.state.stOilChangeLog}
    ptrTitle={"Regional Analysis"}
    pageType="1"
     logUser={userObject}
    expExcel={this.exportExcel}
   />
    <Comp_Ptr_Invoice app_user_id={userObject[0].app_user_id} ref_invoiceId={this.state.stRefInvoice} />
          </div>)
      }
}
export default State_Analysis;